import { Action, Dispatch } from "redux";
import { FGetState } from "../app.reducer";
/**
 * Functon type declare
 */
export type FuncAction = (
    dispatch: Dispatch,
    getState: FGetState
) => Promise<void>;

/**
 * Function sync type declare
 */
export type FuncSyncAction = (dispatch: Dispatch, getState: FGetState) => void;

/**
 * Store action type declare
 */
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    CREATE_TRANSACTION_CODE: {
        LOADING: "INIT_CREATE_TRANSACTION_CODE_LOADING",
        SUCCESS: "INIT_CREATE_TRANSACTION_CODE_SUCCESS",
        ERROR: "INIT_CREATE_TRANSACTION_CODE_ERROR",
    },
};

/**
 * All store state
 */
export interface TopupState {
    isLoading?: boolean;
    error?: any;
}

/**
 * Store's action definition
 */
export interface ITopupAction extends Action {
    payload: any;
    error: any;
}
